import { useQuery } from '@tanstack/react-query';

import { fetchSymbols } from '@/lib/api/symbols';

export interface UseSymbolsOptions {
  enabled?: boolean;
  staleTime?: number;
}

export function useSymbols({ enabled = true, staleTime }: UseSymbolsOptions = {}) {
  return useQuery({
    queryKey: ['symbols'],
    queryFn: ({ signal }) => fetchSymbols({ signal }),
    enabled,
    staleTime,
  });
}

